import React, { useState, useEffect } from 'react';
import { Table, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LeagueTable = ({ season }) => {
    const navigate = useNavigate();
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${BACKEND_URL}/tables/?season=${season}`);
                setTeams(response.data);
            } catch {
                setTeams([]);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [season]);

    const handleRowClick = (teamId) => {
        navigate(`/zespol/${teamId}`);
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Ładowanie...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <div style={{ overflowX: 'auto', width: '100%', maxWidth: 700, marginLeft: 'auto', marginRight: 'auto' }}>
            <Table striped bordered hover className="sticky-col-2" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <thead>
                <tr>
                    <th>#</th>
                    <th></th>
                    <th>Drużyna</th>
                    <th>Pkt.</th>
                    <th>M</th>
                    <th>W</th>
                    <th>R</th>
                    <th>P</th>
                    <th>B</th>
                    <th>RB</th>
                </tr>
            </thead>
            <tbody>
                {Array.isArray(teams) && teams.length > 0 ? (
                    teams.map((team, index) => (
                        <tr key={team.team_id} onClick={() => handleRowClick(team.team_id)} style={{ cursor: 'pointer' }}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'center', padding: '8px 4px' }}>
                            {team.logo_filename && (
                                <img
                                src={`/logos/${team.logo_filename}`}
                                alt={team.team_name}
                                style={{
                                    width: 20,
                                    height: 20,
                                    objectFit: 'cover',
                                }}
                                onError={(e) => (e.currentTarget.style.display = 'none')} // hide if image missing
                                />
                            )}
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                            {team.team_name}
                            </td>
                            <td style={{ textAlign: 'center' }}><strong>{team.points}</strong></td>
                            <td style={{ textAlign: 'center' }}>{team.matches_played}</td>
                            <td style={{ textAlign: 'center' }}>{team.wins}</td>
                            <td style={{ textAlign: 'center' }}>{team.draws}</td>
                            <td style={{ textAlign: 'center' }}>{team.losses}</td>
                            <td style={{ textAlign: 'center' }}>{team.goals_for}:{team.goals_against}</td>
                            <td style={{ textAlign: 'center' }}>{team.goals_for - team.goals_against}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="9">No teams available</td>
                    </tr>
                )}
            </tbody>
        </Table>
        </div>
    );
};

export default LeagueTable;